<!--
@for (card of subscriptionCards; track card) {
<mat-card class="sub-card" appearance="outlined">
  <mat-card-header>
    @if (card.serviceArr){
    <mat-card-title>{{card.serviceArr.length}} {{card.serviceArr.length > 1 ? 'Services' : 'Service'}}</mat-card-title>
    }
    @else {
    <mat-card-title>No Services</mat-card-title>
    }
    <mat-card-subtitle>Created: {{ card.timeStamp | date:'yyyy-MM-dd HH:mm:ss' }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    @for (product of card.stripeProducts; track product){
    <p>{{product.name}}</p>
    }
  </mat-card-content>
  <mat-card-actions>
    <button mat-button (click)="editSubscription(card)">EDIT SUBSCRIPTION</button>
    <button mat-button (click)="deleteSubscription(card)">CANCEL SUBSCRIPTION</button>
  </mat-card-actions>
</mat-card>
}
-->

@if (stripeSubs && stripeSubs.length == 0){
Customer has no Subscriptions yet!
}
@for (sub of stripeSubs; track sub) {
<mat-card class="sub-card" appearance="outlined">
  <mat-card-header>
    @if (sub.metadata.name) {
    <mat-card-title>{{sub.metadata.name}}</mat-card-title>
    }
    @else if (sub.items.data){
    <mat-card-title>{{sub.items.data.length}} {{sub.items.length > 1 ? 'Services' : 'Service'}}</mat-card-title>
    }
    @else {
    <mat-card-title>No Services</mat-card-title>
    }
    <mat-card-subtitle>Created: {{ sub.created * 1000 | date:'yyyy-MM-dd HH:mm:ss' }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    @for (item of sub.items.data; track item){
    <p>{{item.productName}}</p>
    }
  </mat-card-content>
  <mat-card-actions>
    <!--<button mat-button (click)="editSubscription(sub)">EDIT SUBSCRIPTION</button>-->
    <button mat-button [matMenuTriggerFor]="editMenu">EDIT SUBSCRIPTION</button>
    <mat-menu #editMenu="matMenu">
      <button mat-menu-item (click)="editServicesOrPricing(sub)">Change Services Or Pricing</button>
      <button mat-menu-item (click)="editBillingSchedule(sub)">Change Billing Schedule</button>
      <button mat-menu-item (click)="editSubscription(sub)">Change Service Details</button>
    </mat-menu>
    <button mat-button (click)="deleteSubscription(sub)">CANCEL SUBSCRIPTION</button>
  </mat-card-actions>
</mat-card>
}